<template functional>
  <div
    class="top-navigation-element level-item"
    :class="{ 'get-started': props.isGetStarted }"
    v-on="listeners.click ? { click: listeners.click } : null"
  >
    <slot name="icon">
      <img
        v-if="props.iconSrc"
        class="top-navigation-element-icon"
        :class="{ 'get-started-icon': props.isGetStarted }"
        :alt="props.iconAlt"
        :src="props.iconSrc"
        role="presentation"
        v-bind="props.additionalAttrs"
      />
    </slot>
    <span
      :class="[
        'top-navigation-element-text',
        {
          'is-hidden-touch is-hidden-desktop-only': props.hideTextOnTablet,
          'get-started-text': props.isGetStarted
        }
      ]"
      v-bind="props.additionalAttrs"
    >
      {{ props.text }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'TopNavigationElement',
  props: {
    iconSrc: {
      type: [String, null],
      default: null
    },
    text: {
      type: String,
      required: true
    },
    iconAlt: {
      type: String,
      default: 'Icon'
    },
    additionalAttrs: {
      type: Object,
      default: () => {}
    },
    hideTextOnTablet: {
      type: Boolean,
      default: false
    },
    isGetStarted: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/components/level';

.top-navigation-element {
  cursor: pointer;
  color: $white;

  &:not(:last-child) {
    margin-right: 18px;
  }

  &:hover {
    .top-navigation-element-text {
      text-decoration: underline;
    }
  }
}

.get-started {
  background: $white;
  color: $black;
  padding: 10px;
  height: 24px;
  border-radius: 24px;
}

.top-navigation-element-icon {
  width: 24px;
  height: 24px;
  margin-right: 5px;
}

.get-started-icon {
  width: 15px;
  height: 16px;
  margin-right: 8px;
}

.top-navigation-element-text {
  font-weight: 500;
  text-transform: capitalize;
}

.get-started-text {
  font-size: 14px;
  line-height: 21px;
  font-weight: 700;
}
</style>
